"use strict";

/**
*  Встроенная подсказка
*
* @class WebAccess.components.notifications.InlineHint
* @extends BaseObject
* @param {object} [opt_settings] Параметры подсказки
* @param {Integer} [opt_dialogId] ИД подсказки
* @since 5.0.0.7300
*
* @example
* var hint = new WA.CMP.NTF.InlineHint()
* hint.showError("Hello world");
*/
(function (global) {
  var InlineHint = BaseObject.extend({
    _dialogId: 0,
    _customDialogId: false,
    init: function (opt_settings, opt_dialogId) {
      this._super(opt_settings);
      this._dialogId = opt_dialogId;
      if (opt_dialogId) this._customDialogId = true;
      if ($.isPlainObject(opt_settings)) {
        $.extend(this, opt_settings);
      };

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    className: 'InlineHint',

    /**
    * Показать встроенную подсказку с предупреждением.
    *
    * @function  WebAccess.components.notifications.InlineHint#showWarning
    * @param {string} title Основной текст предупреждения
    * @param {string} [description] Информационный текст, объясняющий суть предупреждения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority = INLINE_HINT_PRIORITY.PRIMARY] Приоритет встроенной подсказки
    * @return  {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.0.0.7300
    */
    showWarning(title, description, inlineHintPriority = INLINE_HINT_PRIORITY.PRIMARY) {
      const inlineHintParams = {
        description,
        priority: inlineHintPriority,
        type: MESSAGE_TYPE.WARNING,
      };    
      return this.show(title, inlineHintParams);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать встроенную подсказку с текстом ошибки.
    *
    * @function  WebAccess.components.notifications.InlineHint#showError
    * @param {string} title Основной текст ошибки
    * @param {string} [description] Информационный текст, объясняющий ошибку
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority = INLINE_HINT_PRIORITY.PRIMARY] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    */
    showError(title, description, inlineHintPriority = INLINE_HINT_PRIORITY.PRIMARY) {
      const inlineHintParams = {
        description,
        priority: inlineHintPriority,
        type: MESSAGE_TYPE.ERROR,
      };
      return this.show(title, inlineHintParams);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Показать  встроенную подсказку с информационным сообщением.
    *
    * @method WebAccess.components.notifications.InlineHint#showInfo
    * @param {string} title Основной текст сообщения
    * @param {string} [description] Информационный текст, объясняющий суть сообщения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.1.0.1511
    */
    showInfo(title, description, inlineHintPriority) {
      const inlineHintParams = {
        description,
        priority: inlineHintPriority,
        type: MESSAGE_TYPE.INFO,
      };
      return this.show(title, inlineHintParams);
    },

    /**
    * Показать подсказку в указанном контейнере
    * @function WebAccess.components.notifications.InlineHint#showInContainer
    * @param {string} containerSelector Селектор контейнера для сообщения
    * @param {string} title Основной текст сообщения
    * @param {string} [description] Информационный текст
    * @param {MESSAGE_TYPE} [messageType] Тип сообщения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint
    */
    showInContainer(containerSelector, title, description, messageType, inlineHintPriority) {
      const inlineHintParams = {
        containerSelector,
        description,
        priority: inlineHintPriority,
        type: messageType,
      };
      return this.show(title, inlineHintParams);
    },    

    /**
    * Показать подсказку в диалоге
    * @function WebAccess.components.notifications.InlineHint#showInDialog
    * @param {string} dialogId Идентификатор целевого диалога
    * @param {string} title Основной текст сообщения
    * @param {string} [description] Информационный текст
    * @param {MESSAGE_TYPE} [messageType] Тип сообщения
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint
    */
    showInDialog(dialogId, title, description, messageType, inlineHintPriority) {
      this._dialogId = dialogId;
      this._customDialogId = true;
      const inlineHintParams = {
        description,
        priority: inlineHintPriority,
        type: messageType,
      };
      return this.show(title, inlineHintParams);
    },

    _updateContext: function () {
      if (this._customDialogId) return;

      this._dialogId = null;

      var jDialog = $('.ui-dialog-content').last();
      if (!jDialog.length) return;
      var jDialogContent = jDialog.children();
      if (jDialogContent.length) {
        this._dialogId = jDialogContent.attr('id');
        if (typeof this._dialogId !== 'undefined') {
          this._dialogId = this._dialogId.replace('dialog_content_', '');
        }
      }
    },

    /**
     * Сформировать модель встроенной подсказки.
     *
     * @method WebAccess.components.notifications.InlineHint#_prepareHintModel
     * @param {...*} args Аргументы метода show, из которых будет формироваться модель встроенной подсказки
     * @private
     * @return {Object} Модель встроенной подсказки.
     * @since 5.7.0.2201
     */
    _prepareHintModel(...args) {
      let hintModel = {};

      // Начиная с версии 5.6 метод show нужно вызывать так: show(title, params);
      if ((!args[1] || typeof args[1] !== 'object') && args.length >= 2) {
        // Приводим аргументы в современный вид и сообщаем о том, что по-старому пользоваться не рекомендуется
        this._warnAboutDeprecatedMethod('WA.CMP.NTF.InlineHint.show', 'Устаревший вариант использования аргументов метода {0}');
        hintModel = {
          description: args[1],
          priority: args[3],
          type: args[2],
        };
      } else {
        if (args[1]) {
          hintModel = args[1];
          // Раньше вместо description был message
          if (typeof hintModel.message === 'string') {
            this._warnAboutDeprecatedMethod('WA.CMP.NTF.InlineHint.show', 'Устаревший вариант использования аргументов метода {0}');
            hintModel.description = hintModel.message;
            delete hintModel.message;
          }
        }
      }

      // Устанавливаем значения по умолчанию.
      if (typeof hintModel.description !== 'string') {
        hintModel.description = '';
      }
      if (!Object.values(INLINE_HINT_PRIORITY).includes(hintModel.priority)) {
        hintModel.priority = INLINE_HINT_PRIORITY.SECONDARY;
      }
      if (!Object.values(MESSAGE_TYPE).includes(hintModel.type)) {
        hintModel.type = MESSAGE_TYPE.ERROR;
      }

      let title = args[0].toString();


      // Пробуем распарсить JSON, на случай, если в метод первым параметром был передан JSON-объект
      try {
        let jsonObject = JSON.parse(title);
        if (jsonObject.Message) {
          title = jsonObject.Message;
        }
      } catch (e) {
        // Игнорируем, если title не является JSON-объектом
      }

      title.trim().replace(/\n/g, '<br>').replaceAll("\u0026quot;", '"');

      if (title.includes('^')) {
        const splitterIndex = title.indexOf('^');
        hintModel.description = title.substring(splitterIndex + 1).fromISBuilderToNormal();
        title = title.substring(0, splitterIndex);
      }

      hintModel.title = title;

      return hintModel;
    },

    /**
     * Показать встроенную подсказку.
     *
     * @method WebAccess.components.notifications.InlineHint#show
     * @param {string} title Основной текст сообщения
     * @param {string} [params = {}] Дополнительные параметры
     * @param {string} [params.containerSelector] Селектор контейнера для сообщения
     * @param {string} [params.description = ''] Информационный текст
     * @param {string} [params.priority = INLINE_HINT_PRIORITY.SECONDARY] Приоритет встроенной подсказки
     * @param {string} [params.type = MESSAGE_TYPE.ERROR] Тип сообщения
     * подсказки @deprecated since 5.6.0.9069
     * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
     */
    show(title, params = {}) {
      // Подготавливаем модель подсказки
      let hintModel = this._prepareHintModel(...arguments);

      this._updateContext();

      if (!hintModel.title) {
        return this;
      }

      const templateParams = {
        cssClass: (hintModel.priority === INLINE_HINT_PRIORITY.SECONDARY) ? ' inline-hint_priority_secondary' : '',
        description: hintModel.description,
        title: hintModel.title,
        type: Object.keys(MESSAGE_TYPE)[hintModel.type].toLowerCase(),
      };

      WA.TMPL.render('components/inlineHint.compile.html', templateParams).done((html) => {  
        // Прячем предыдущую подсказку с таким же inlineHintPriority
        this.hide(hintModel.priority);     
        
        // Находим контейнер ошибки в DOM, в которм будем рендерить inline-hint
        let jContainer = hintModel.containerSelector ? $(hintModel.containerSelector) : {};
        if (!jContainer.length) {
          const defaultContainerSelectors = Object.freeze([
            `#dialog_content_${this._dialogId}:visible`, // В диалоге
            '.preview-container__inline-hint', // В предпросмотре
            '#ctl00_MainContent_ErrorContainer', // В карточках и в МД
            '[name="ErrorControl"]', // В проводнике
            '#right_column', // Неизвестно где, оставлено лишь бы чего не сломать
          ]);
          for (const defaultContainerSelector of defaultContainerSelectors) {
            jContainer = $(defaultContainerSelector);
            if (jContainer.length) {
              break;
            }
          }
        }

        // Добавляем inline-hint с низким приоритетом после inline-hint'а с высоким приоритетом
        const jErrorContainerPrimary = jContainer.find('.inline-hint').not('.inline-hint_priority_secondary');
        if (jErrorContainerPrimary.length) {
          jErrorContainerPrimary.after(html);
        } else {
          jContainer.prepend(html);
        }

        // Получаем только что добавленный inline-hint
        let jCurrentErrorContainer;
        switch (hintModel.priority) {
          case INLINE_HINT_PRIORITY.PRIMARY:
            jCurrentErrorContainer = jContainer.find('.inline-hint').not('.inline-hint_priority_secondary');
            break;
          case INLINE_HINT_PRIORITY.SECONDARY:
            jCurrentErrorContainer = jContainer.find('.inline-hint_priority_secondary');
        }

        // Навешиваем событые удаления inline-hint при нажатии на крестик
        jCurrentErrorContainer.find('.inline-hint__close').on('click', () => {
          this.hide(hintModel.priority);
        });
      });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть последнее открытое сообщение.
    *
    * @function WebAccess.components.notifications.InlineHint#hide
    * @param {INLINE_HINT_PRIORITY} [inlineHintPriority] Приоритет встроенной подсказки
    * @return {WebAccess.components.notifications.InlineHint} Объект типа InlineHint.
    * @since 5.0.0.7300
    */
    hide(inlineHintPriority = null) {
      switch (inlineHintPriority) {
        case INLINE_HINT_PRIORITY.PRIMARY:
          $('.inline-hint').not('.inline-hint_priority_secondary').remove();
          break;
        case INLINE_HINT_PRIORITY.SECONDARY:
          $('.inline-hint_priority_secondary').remove();
          break;
        default:
          global.InlineHint.hideAll();
      }
      return this;
    },

  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~!!~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.InlineHint = InlineHint;

  /**
  * Скрыть все сообщения.
  *
  * @function WebAccess.components.notifications.InlineHint#hideAll
  * @static
  * @since 5.0.0.7300
  */
  global.InlineHint.hideAll = function () {
    $('.inline-hint').add('.error_div_msg').add('#error_container').remove();
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})(window.WebAccess.components.notifications);